import { createSlice } from '@reduxjs/toolkit';
import { httpPost } from '../../../util/Rest';
import { httpGet } from '../../../util/Rest';
import _ from 'lodash';
import { submissionEnd } from '../CommonActions/commonActions';
import { fetchDownloadSuccess } from '../PreviewFileData';

const initialState = {
  successMsg: null,
  notesSuccessMsg: null,
  errorMsg: null,
  isLoading: false,
  addHeaderStatus: null,
  addScheduleStatus: null,
  addAdditionalInfoStatus: null,
  addWorkQueueStatus: null,
  filterData: [],
  executionData: [],
  wqCode: '',
  reportName: '',
  addFilterStatus: null,
  addFieldListStatus: null,
  reportFieldsPostStatus: null,
  reportMasterData: {},
  reportFieldsData: [],
  workQueueFieldsData: [],
  ScheduleData: {},
  reportFieldsSortData: [],
  workQueueSortFieldsData: [],
  reportDateStampFields: [],
  basicInfoData: {},
  fieldlListData: {},
  additionalInfoData: {},
  WorkQueueData: {},
  getfilterData: {},
  copyReportStatus: null,
  copyWorkQueueStatus: null,
  iscopyLoading: false,
  copySuccessMsg: null,
  copyErrorMsg: null,
  actionData: [],
  wqCodeData: [],
  reportCreatedForData: [],
  fixedlength: '',
  isDraftReport: 'Y',
  isWorkqueueAddClicked: false,
  initialSave: false,
  lastStep: 0,
  createdByData: [],
  createdForData: [],
  workQueueNameAllData: [],
  isSystemNoteLoading: null,
  systemNotesStatus: null,
  testFilterResponse: [],
};

const addWorkQueue = createSlice({
  name: 'addWorkQueue',
  initialState,
  reducers: {
    fetchStart: (state) => {
      state.isLoading = true;
      state.errorMsg = null;
    },
    fetchCopy: (state) => {
      state.iscopyLoading = true;
      state.errorMsg = null;
    },
    fetchError: (state, action) => {
      state.errorMsg = action.payload;
      state.isLoading = false;
    },
    fetchCopyError: (state, action) => {
      state.copyErrorMsg = action.payload;
      state.iscopyLoading = false;
    },
    postHeaderData: (state, action) => {
      state.addHeaderStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.wqCode = action.payload?.response?.workqueueId;
      state.fixedlength = action.payload?.response?.fixedLength;
      state.reportName = action.payload?.response?.workqueueName;
    },
    postFilterData: (state, action) => {
      state.addFilterStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.wqCode = action.payload.response.workqueueId;
      state.reportName = action.payload?.response?.workqueueName;
    },
    postFieldListData: (state, action) => {
      state.addFieldListStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    postScheduleData: (state, action) => {
      state.addScheduleStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    getReportMasterData: (state, action) => {
      state.reportMasterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getReportFieldsData: (state, action) => {
      state.workQueueFieldsData = action.payload?.workQueueFields;
      state.workQueueSortFieldsData = action.payload?.workQueueSortFields;
      state.reportDateStampFields = action.payload?.reportDateStampFields;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getWqCodeData: (state, action) => {
      state.wqCodeData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getWorkQueueNameData: (state, action) => {
      state.workQueueNameAllData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getCreatedByData: (state, action) => {
      state.createdByData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getCreatedForData: (state, action) => {
      state.createdForData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },

    getReportCreatedForData: (state, action) => {
      state.reportCreatedForData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getScheduleData: (state, action) => {
      state.ScheduleData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    getFieldListData: (state, action) => {
      state.fieldlListData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
    },
    postReportFieldsData: (state, action) => {
      state.reportFieldsPostStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
      state.wqCode = action?.payload?.response?.length
        ? action.payload.response[0].workqueueId
        : '';
      state.reportName = action?.payload?.response?.length
        ? action.payload.response[0].workqueueName
        : '';
    },
    getAdditionalInfoData: (state, action) => {
      state.additionalInfoData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getWorkQueueData: (state, action) => {
      state.WorkQueueData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    postAdditionalInfoData: (state, action) => {
      state.addAdditionalInfoStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    postWorkQueueData: (state, action) => {
      state.addWorkQueueStatus = action.payload?.status;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = action.payload?.message;
    },
    getFilterData: (state, action) => {
      state.filterData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getRunExecutionData: (state, action) => {
      state.executionData = action.payload;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getFilterDatas: (state, action) => {
      state.getfilterData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
    },
    getBasicInfoData: (state, action) => {
      state.basicInfoData = action.payload?.response;
      state.isLoading = false;
      state.errorMsg = null;
      state.successMsg = null;
      state.reportName = action?.payload?.response?.workqueueName;
    },
    setReduxState: (state, action) => {
      state[action.payload.property] = action?.payload?.value;
    },
    postCopyReportData: (state, action) => {
      state.copyReportStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      state.copyCode = action.payload?.response?.reportId;
      state.wqCode = action.payload?.response?.reportId;
      state.reportName = action.payload?.response?.workqueueName;
    },
    postCopyWorkQueueData: (state, action) => {
      state.copyWorkQueueStatus = action.payload?.status;
      state.iscopyLoading = false;
      state.copySuccessMsg = action.payload?.message;
      state.copyErrorMsg = null;
      // state.copyCode = action.payload?.response?.reportId;
      state.wqCode = action.payload?.response?.workqueueId;
      state.reportName = action.payload?.response?.workqueueName;
    },
    resetMsg: (state, action) => {
      if (action.payload === 'search') {
        // state.wqCode = "";
        state.errorMsg = null;
        state.reportName = '';
        state.lastStep = 0;
      } else {
        state.successMsg = null;
        state.errorMsg = null;
        state.isLoading = false;
        state.addHeaderStatus = null;
        state.addFilterStatus = null;
        state.addFieldListStatus = null;
        // state.getfilterData = {};
        // state.actionData = null
      }
    },
    resetReportFieldsStatus: (state) => {
      state.reportFieldsPostStatus = null;
      state.successMsg = null;
      state.errorMsg = null;
      state.isLoading = false;
    },
    resetFilterData: (state, action) => {
      state.filterData = [];
      state.isLoading = false;
    },
    resetReportScheduleData: (state) => {
      state.ScheduleData = {};
    },
    resetWorkQueueSetupData: (state, action) => {
      state.reportMasterData = {};
      state.isLoading = false;
      state.basicInfoData = {};
      state.fieldlListData = {};
      state.getfilterData = {};
      state.additionalInfoData = {};
      state.wqCode = '';
    },
    resetCopyReportData: (state, action) => {
      state.copyReportStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
    resetCopyWorkQueueData: (state, action) => {
      state.copyWorkQueueStatus = null;
      state.iscopyLoading = false;
      state.copySuccessMsg = null;
      state.copyErrorMsg = null;
    },
    resetAdditionalInfoData: (state, action) => {
      state.addAdditionalInfoStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetWorkQueueData: (state, action) => {
      state.addWorkQueueStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },

    resetScheduleData: (state, action) => {
      state.addScheduleStatus = null;
      state.successMsg = null;
      state.isLoading = false;
      state.errorMsg = null;
    },
    resetReportFieldsData: (state) => {
      state.workQueueFieldsData = [];
      state.workQueueSortFieldsData = [];
      state.reportDateStampFields = [];
    },
    resetCreateReportData: (state) => {
      state.lastStep = 0;
    },
    resetExecutionData: (state) => {
      state.executionData = [];
    },
    setDockey: (state, action) => {
      state.isLoading = false;
      state.dockey = action.payload;
    },
    resetDockey: (state) => {
      state.dockey = '';
    },
    setConfigUrl: (state, action) => {
      state.isLoading = false;
      state.configurationUrl = action.payload;
    },
    resetConfigUrl: (state) => {
      state.configurationUrl = '';
    },
    fetchNoteStart: (state) => {
      state.isSystemNoteLoading = true;
      state.errorMsg = null;
    },
    postSystemNotesData: (state, action) => {
      state.systemNotesStatus = action.payload.status;
      state.isSystemNoteLoading = false;
      state.isLoading = false;
      state.errorMsg = null;
      state.notesSuccessMsg = action.payload.response;
    },
    resetSystemNotesData: (state) => {
      state.isSystemNoteLoading = false;
      state.systemNotesStatus = null;
      state.notesSuccessMsg = null;
      state.errorMsg = null;
    },
    postWorkFiltersData: (state, action) => {
      state.testFilterResponse = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
    testFilterResetData: (state, action) => {
      state.testFilterResponse = [];
    },
    fetchSuccess: (state, action) => {
      state.successMsg = action.payload.message;
      state.isLoading = false;
    },
    postTestFilterRuleGroupData: (state, action) => {
      state.testFilterResponse = action.payload.response;
      state.isLoading = false;
      state.errorMsg = null;
    },
  },
});
export default addWorkQueue.reducer;
export const {
  postTestFilterRuleGroupData,
  fetchSuccess,
  testFilterResetData,
  postWorkFiltersData,
  postSystemNotesData,
  resetSystemNotesData,
  setDockey,
  fetchNoteStart,
  setConfigUrl,
  resetConfigUrl,
  resetDockey,
  fetchStart,
  fetchError,
  resetMsg,
  postHeaderData,
  getReportMasterData,
  getReportFieldsData,
  getScheduleData,
  getFilterData,
  resetFilterData,
  postFilterData,
  postFieldListData,
  getBasicInfoData,
  getFieldListData,
  getAdditionalInfoData,
  getWorkQueueData,
  postScheduleData,
  getFilterDatas,
  resetWorkQueueData,
  resetWorkQueueSetupData,
  fetchCopy,
  postCopyReportData,
  resetCopyReportData,
  fetchCopyError,
  postReportFieldsData,
  postAdditionalInfoData,
  postWorkQueueData,
  getWqCodeData,
  resetReportFieldsData,
  getReportCreatedForData,
  resetReportFieldsStatus,
  setReduxState,
  resetAdditionalInfoData,
  resetScheduleData,
  getRunExecutionData,
  postCopyWorkQueueData,
  resetCopyWorkQueueData,
  resetCreateReportData,
  resetExecutionData,
  getCreatedByData,
  getCreatedForData,
  resetReportScheduleData,
  getWorkQueueNameData,
} = addWorkQueue.actions;

export const printWorkqueueMaster = (payload, printData) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueuesetup/generateurlprintworkqueuesetup`, payload)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          // dispatch(fetchSuccess(printData));
          //  download(data.data);
          dispatch(fetchDownloadSuccess(printData));
          dispatch(setConfigUrl(data?.data || ''));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};
export const postPrintWorkqueueMaster = (data) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueuesetup/download/workqueue`, data)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(printWorkqueueMaster({ dockey: data?.message }, data));
          dispatch(setDockey(data?.message));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.message));
      });
  };
};

export const postHeaderInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueuesetup/save/workqueue/basicinfo`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postHeaderData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchBasicInfo = (wqCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/workqueue/basicinfo/${wqCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getBasicInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const getAllWqCodeData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/find/all/workqueuenameanddescription`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWqCodeData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchWorkQueue = (wqId) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/workqueue/addinfo/${wqId}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postCopyWorkQueue = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`workqueuesetup/save/copy/workQueuesetup`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyWorkQueueData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};
// above are used APIs
export const postFilter = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(submissionEnd());
    httpPost(`workqueuesetup/save/workqueuerules`, _.omit(details, 'isTestClicked'))
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFilterData(data));
          if (details?.isTestClicked) {
            dispatch(fetchFilter(data?.response));
          }
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFilter = (wqCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/workqueuerules/${wqCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFilterDatas(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postSystemNotes = (details) => {
  return (dispatch) => {
    dispatch(fetchNoteStart());
    httpPost(`workqueuesetup/save/workqueueusernotes`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postSystemNotesData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const resetSystemNotes = () => {
  return (dispatch) => {
    dispatch(resetSystemNotesData());
  };
};

export const postWorkFilterTest = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueuesetup/test/workqueuerule/expression`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
        } else if (data?.status === 200 && !data?.response.count) {
          dispatch(fetchError('There are currently no accounts in this work queue.'));
        } else if (data && data.status && data.status === 200) {
          dispatch(postWorkFiltersData(data));
          dispatch(fetchSuccess('success'));
        } else if (data && data.status && data.status === 500) {
          dispatch(fetchError(data.statusText));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postTestFilterRuleGroup = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`rules/test/filtergroup/expressions`, details)
      .then((data) => {
        if (data?.status === 200 && data?.data?.status === 400) {
        } else if (data && data.status && data.status === 200) {
          dispatch(postTestFilterRuleGroupData(data));
          dispatch(fetchSuccess('success'));
        } else if (data && data.status && data.status === 500) {
          dispatch(fetchError(data.statusText));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

// above api's are filter step
export const postFieldList = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`reportstransaction/save/report/fieldlistcode`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postFieldListData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAdditionalInfo = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(submissionEnd());
    httpPost(`reportstransaction/save/reportaddinfo`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postAdditionalInfoData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const postAdditionalInfoWorkQueue = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`workqueuesetup/save/workqueue/addinfo`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postWorkQueueData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postScheduleDetails = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpPost(`schedule/save/report/schedule`, details)
      .then((data) => {
        dispatch(submissionEnd());
        if (data && data.status && data.status === 200) {
          dispatch(postScheduleData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postWorkqueueFieldsDetails = (details) => {
  return (dispatch) => {
    dispatch(fetchStart());
    dispatch(submissionEnd());
    httpPost(`workqueuesetup/save/workqueuefields`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postReportFieldsData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchWorkqueueFields = (code) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/workqueuefields/${code}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getReportFieldsData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
// Above api's are used in workqueue step

export const fetchFilterData = (fieldListCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`rules/find/all/filtergroup/${fieldListCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFilterData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchExecutionReportData = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`report/execution/findall/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getRunExecutionData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
// export const fetchReportMaster = (reportMasterId) => {
//   return (dispatch) => {
//     dispatch(fetchStart());
//     httpGet(`reportstransaction/get/report/${reportMasterId}`)
//       .then((data) => {
//         if (data && data.status && data.status === 200) {
//           dispatch(getReportMasterData(data.response));
//         } else {
//           dispatch(fetchError(data?.data?.error));
//         }
//       })
//       .catch((error) => {
//         dispatch(fetchError(error.message));
//       });
//   };
// };

export const fetchSchedule = (reportCode, batchTriggers, frameworkScheduleId, tabType) => {
  // const URL = batchTriggers
  //   ? "schedule/find/batchtrigger/schedule"
  //   : "schedule/find/report/schedule";
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`schedule/find/report/schedule/${frameworkScheduleId}/${tabType}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getScheduleData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const fetchFieldList = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/report/fieldlistcode/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getFieldListData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};
export const fetchAdditionalInfo = (reportCode) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/find/report/${reportCode}`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getAdditionalInfoData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error.message));
      });
  };
};

export const postCopyReport = (details) => {
  return (dispatch) => {
    dispatch(fetchCopy());
    httpPost(`reportstransaction/save/copy/report`, details)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(postCopyReportData(data));
        } else {
          dispatch(fetchCopyError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchCopyError(error.message));
      });
  };
};

export const getAllWorkqueueNameData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`reportstransaction/get/workqueue/name`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getWorkQueueNameData(data));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const getAllReportCreatedForData = () => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`get/all/username`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          let dataReformed = [];
          dataReformed =
            data &&
            data?.response?.length > 0 &&
            data?.response?.map((i) => {
              return { userName: i?.userLoginName };
            });
          dispatch(getReportCreatedForData(dataReformed));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};
export const fetchCreatedByDropDownData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`workqueuesetup/get/${type}/createdby`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCreatedByData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const fetchCreatedForDropDownData = (type) => {
  return (dispatch) => {
    dispatch(fetchStart());
    httpGet(`searchcreatedby/get/${type}/createdfor`)
      .then((data) => {
        if (data && data.status && data.status === 200) {
          dispatch(getCreatedForData(data.response));
        } else {
          dispatch(fetchError(data?.data?.error));
        }
      })
      .catch((error) => {
        dispatch(fetchError(error?.data?.error));
      });
  };
};

export const resetFilter = () => {
  return (dispatch) => {
    dispatch(resetFilterData());
  };
};
export const resetMessage = (page) => {
  return (dispatch) => {
    dispatch(resetMsg(page));
  };
};
export const resetReportFields = () => {
  return (dispatch) => {
    dispatch(resetReportFieldsStatus());
    dispatch(resetReportFieldsData());
  };
};
export const resetWorkQueueSetupdata = () => {
  return (dispatch) => {
    dispatch(resetWorkQueueSetupData());
  };
};
export const resetCopyReport = () => {
  return (dispatch) => {
    dispatch(resetCopyReportData());
  };
};
export const resetCopyWorkQueue = () => {
  return (dispatch) => {
    dispatch(resetCopyWorkQueueData());
  };
};
export const resetAdditionalInfo = () => {
  return (dispatch) => {
    dispatch(resetAdditionalInfoData());
  };
};
export const resetWorkQueue = () => {
  return (dispatch) => {
    dispatch(resetWorkQueueData());
  };
};

export const resetSchedule = () => {
  return (dispatch) => {
    dispatch(resetScheduleData());
  };
};
export const resetExecution = () => {
  return (dispatch) => {
    dispatch(resetExecutionData());
  };
};
export const resetReportSchedule = () => {
  return (dispatch) => {
    dispatch(resetReportScheduleData());
  };
};
export const resetCreateReport = () => {
  return (dispatch) => {
    dispatch(resetCreateReportData());
  };
};
